import { render, staticRenderFns } from "./SketchBuilder.vue?vue&type=template&id=3294eef2&scoped=true"
import script from "./SketchBuilder.vue?vue&type=script&lang=js"
export * from "./SketchBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3294eef2",
  null
  
)

export default component.exports